import React from 'react';
import { EditableInfo } from '@icoach/components';
import { Icons, Box, Stack } from "@curves/ui-base";

const GuidanceNotesBox = ({ className, guidanceNotes, onEdit }) => {
    return (
        <EditableInfo
            label={
                <Stack alignItems={'center'}>
                    <Icons.WorkoutGuide className="mr-1" />
                    <Box className="editable-info__title mb-0">指導注意</Box>
                </Stack>
            }
            onEdit={onEdit}
            className={className}
            isMultiline
        >
            {guidanceNotes || <span className={'font-color-4'}>無相關資料</span>}
        </EditableInfo>
    );
};

export default GuidanceNotesBox;
